import { ShowProcessRequestSchema, ShowProcessResponseSchema } from './show-process.schema';
/**
 * Show Process Endpoint Contract
 * Retrieves a specific process by ID
 */ export const showProcessContract = {
    method: 'GET',
    path: '/api/v2/process/:id',
    description: 'Retrieve a specific process by ID',
    requestSchema: ShowProcessRequestSchema,
    responseSchema: ShowProcessResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            404: 'Process not found'
        }
    }
};

//# sourceMappingURL=show-process.contract.js.map